module.exports = __webpack_public_path__ + "img/arrow_hor.99580736.svg";